<template>
  <v-breadcrumbs class="pl-0 mb-0" :items="breadcrumbs" divider="|">
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item :href="getURLLocalGlobal(item.href)"
                          @click="goToPage(item.href, $event)" :disabled="item.disabled">

        <template v-if="item.last">
          <strong class="last-leaf">{{ item.text | stripHtml }}</strong>
        </template>
        <template v-else>{{ item.text | stripHtml }}</template>
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<style scoped>
.last-leaf {
  white-space: nowrap;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<script>

import globalMixins from "@/mixins/globalMixins";

export default {
  name: 'BreadCrumbs',
  props: {
    context: {
      type: Array
    }
  },

  mixins: [globalMixins],

  data() {
    return {
      breadcrumbs: []
    }
  },

  created() {

    if (this.context) {
      let counter = 0;
      let max = this.context.length;
      this.context.forEach((oneBreadCrumb) => {
        if (!oneBreadCrumb.disableUrlInBreadcrumb) {

          var breadcrumbsText = (oneBreadCrumb.title && oneBreadCrumb.title.trim() !== '') ? oneBreadCrumb.title : oneBreadCrumb.name;
          if (oneBreadCrumb.contentType === 'objHerbalGramIssue') {
            breadcrumbsText = `Issue #${this.extractNumber(oneBreadCrumb.name)}`;
          }

          this.breadcrumbs.push({
            text: breadcrumbsText,
            href: oneBreadCrumb.url,
            type: oneBreadCrumb.contenttype,
            disabled: oneBreadCrumb.iscurrent || oneBreadCrumb.disableUrlInBreadcrumb,
            first: counter === 0,
            last: counter === max - 1
          });
        }

        counter++;
      })
    }
  },

  watch: {
    "$store.state.breadCrumbs.breadcrumbs": {
      deep: true,
      handler(newValue) {
        if (newValue && newValue.text) {
          this.updateEntry(this.breadcrumbs.length - 1, newValue)
        }
      }
    }
  },

  methods: {
    updateEntry(position, context) {
      if (context.href) {
        this.breadcrumbs[position].href = context.href;
      }

      if (context.text) {
        this.breadcrumbs[position].text = context.text;
      }

      if (context.disabled) {
        this.breadcrumbs[position].disabled = context.disabled;
      }
    }
  }
}
</script>